import { useContext } from 'react';
import { getCachedMediaUrl, urlToFile } from '../../../../../lib/utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from '../../../../../Features/storefrontSlice';
// import { showToast } from '../../../../../Components/Toaster/Toaster';
import { CropImageContext } from '../../../../../Context/CropImageContext';

function ImageBox({ media }) {
    const dispatch = useDispatch();
    const mediaSelectionType = useSelector((state) => state.storefront.mediaSelectionType);

    const { setImageToCrop, setModalOpen, setAspectRatio } = useContext(CropImageContext);

    async function handleMediaClick() {
        let imageUrl = media.pic?.replace(
            "https://imageserver.xenie.in/",
            "https://hyprcom-public.s3.ap-south-1.amazonaws.com/"
        );

        const file = await urlToFile(imageUrl, 'cropped-image.jpg');
        setImageToCrop(file);

        dispatch(closeModal());

        if (mediaSelectionType === 'BACKGROUND') {
            setAspectRatio(15 / 8);
        } else if (mediaSelectionType === 'LOGO') {
            setAspectRatio(1 / 1);
        }

        setModalOpen(true);
    }

    return (
        <div onClick={handleMediaClick} className='w-full aspect-square cursor-pointer flex items-center justify-center'>
            <img className='max-w-full max-h-full' src={getCachedMediaUrl(media.pic)} alt="" />
        </div>
    );
}

export default ImageBox;
